import { render } from "./EditorTypeComponent.vue?vue&type=template&id=74dd8065&scoped=true"
import script from "./EditorTypeComponent.vue?vue&type=script&lang=js"
export * from "./EditorTypeComponent.vue?vue&type=script&lang=js"

import "./EditorTypeComponent.vue?vue&type=style&index=0&id=74dd8065&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dd8065"]])

export default __exports__